module.exports = __webpack_public_path__ + "img/2.29694bbe.png";